<template>
  <div class="ws-demo-exams">
    <ws-date-filter :date.sync="date" @change="onDateFilter" />
    <ws-demo-exams-filter ref="filter" @change="onFilter" />
    <section class="ws-demo-exams__content">
      <ws-list-view
        class="ws-demo-exams__list"
        :class="{
          'is-pending': isPending,
          'is-loading': isMy ? isMyFindPending : isFindPending
        }"
        :data="isMy ? myList : list"
        :header="false"
        :skeleton="isPending"
        :placeholder="
          currentRole === 'front_me'
            ? 'Экзамены в которых вы являетесь Главным Экспертом отсутствуют'
            : 'Ничего не найдено'
        "
        :detailed="false"
      >
        <template slot="empty" v-if="isFilterEnabled">
          <span v-if="this.filter && this.filter.humanreadble">
            {{ $t("Экзамен не найден или у вас нет к нему доступа") }}
          </span>
          <span v-else>
            {{
              $t("Результатов, подходящих под выбранные фильтры не найдено.")
            }}
            <a href="" @click.prevent="disableFilters()">{{
              $t("Отключить фильтры")
            }}</a>
          </span>
        </template>
        <ws-demo-exams-card-list slot-scope="props" :exam="props.row" :curators="curators[
              props.row.shifts[0] &&
              props.row.shifts[0].groups[0] &&
              props.row.shifts[0].groups[0].university &&
              props.row.shifts[0].groups[0].university
                ? props.row.shifts[0].groups[0].university.guid
                : props.row.de_center.parent.guid
            ]" :curatorsObject="curators" />
        <template slot="skeleton">
          <ws-list-view-skeleton-item
            :height="'30px'"
            :boxCount="2"
            :boxHeights="['30px', '15px']"
          />
          <ws-list-view-skeleton-item :height="'10px'" :boxCount="0" />
          <ws-list-view-skeleton-item
            :height="'25px'"
            :boxCount="2"
            :boxHeights="['25px', '15px']"
          />
          <ws-list-view-skeleton-item
            :height="'25px'"
            :boxCount="2"
            :boxHeights="['25px', '15px']"
          />
          <ws-list-view-skeleton-item :height="'10px'" :boxCount="0" />
          <ws-list-view-skeleton-item
            :height="'25px'"
            :boxCount="2"
            :boxHeights="['25px', '15px']"
          />
          <ws-list-view-skeleton-item
            :height="'25px'"
            :boxCount="1"
            :boxHeights="['25px']"
          />
          <ws-list-view-skeleton-item :height="'20px'" :boxCount="0" />
          <ws-list-view-skeleton-item
            :height="'25px'"
            :boxCount="1"
            :boxHeights="['25px']"
          />
          <ws-list-view-skeleton-item :height="'40px'" :boxCount="0" />
          <ws-list-view-skeleton-item
            :height="'25px'"
            :boxCount="2"
            :boxHeights="['25px', '25px']"
          />
        </template>
      </ws-list-view>
    </section>
    <footer class="ws-de-center__footer">
      <ws-pagination
        @change="onPageChange"
        :align="'right'"
        :totalItems="isMy ? myPagination.total : pagination.total"
        :itemsPerPage="isMy ? myPagination.per_page : pagination.per_page"
        :disabled="isPending"
        :show-page-options="true"
        :currentIndex="
          isMy ? myPagination.current_page : pagination.current_page - 1
        "
      >
      </ws-pagination>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import getPhoneNumber from '@/utils/getPhoneNumber'
import getAddress from '@/utils/getAddress'
// import WsExpertsManagement from '@/components/de/modals/WsExpertsManagement'
// import WsMainExpertManagement from '@/components/de/modals/WsMainExpertManagement'
import examsListMixin from '@/mixins/exams-list.mixin'
import { constants } from '@/services/constants.service'
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'
import getCountOfParticipants from '@/utils/getCountOfParticipants'
import expertStatus from './data/expertStatusEnum'
import WsMainExpertHistory from '@/components/de/demo-exams/modals/WsMainExpertHistory'
// import WsTechnicalExpertsManagement from '@/components/de/modals/WsTechnicalExpertsManagement'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
// import { get } from 'lodash-es'
// import WsExamExpertLog from '@/components/de/demo-exams/modals/WsExamExpertLog'
import { getAllParticipants } from '@/components/de/demo-exams/data/log-data'

import WsDemoExamsCardList from './WsDemoExamsCardList.vue'

const nullGuid = '00000000-0000-0000-0000-000000000000'
export default {
  name: 'WsDemoExamsList',
  mixins: [examsListMixin, isBlockedExam],
  components: {
    WsDemoExamsCardList
  },
  data () {
    return {
      ready: 0,
      flags: '',
      isStatusUpdating: false,
      constants,
      expertStatus,
      nullGuid,
      curators: {}
    }
  },
  watch: {
    ready (value) {
      if (value > 0) {
        this._fetch()
      }
    }
  },

  computed: {
    ...mapState('exams', {
      isFindPending: 'isFindPending',
      pagination: 'pagination'
    }),
    ...mapState('my-exams', {
      isMyFindPending: 'isFindPending',
      myPagination: 'pagination'
    }),
    ...mapGetters('my-exams', {
      myList: 'list'
    }),
    ...mapState('authentication', ['user', 'currentRole']),
    ...mapGetters('exams', {
      list: 'list'
    }),
    isDisabledDateFilter () {
      return this.isFindPending
    },
    isMy () {
      return this.currentRole === 'front_me' || this.currentRole === 'front_le' || this.currentRole === 'front_tech_expert'
    },
    isPending () {
      return (
        (this.isMy ? this.isMyFindPending : this.isFindPending) &&
        this.list.length === 0
      )
    }
  },
  methods: {
    ...mapActions('exams', ['find', 'remove', 'create', 'update']),
    ...mapActions('my-exams', {
      findMy: 'find'
    }),
    ...mapActions('refbook/curators', {
      'findCurators': 'create'
    }),
    ...mapMutations('exams', ['clearAll', 'updateItem']),
    ...mapMutations('my-exams', {
      clearAllMy: 'clearAll',
      updateMyItem: 'updateItem'
    }),
    getPhoneNumber,
    getAddress,
    async onDate () {
      await this._fetch()
    },

    getCountOfParticipants (exam) {
      return getCountOfParticipants(exam)
    },
    getParticipants (exam) {
      const groups = exam.shifts
        ? [...exam.shifts.map(item => item.groups || [])].flat()
        : []
      return groups.map(group => group.participants || []).flat()
    },
    getCapacityOfParticipants (exam) {
      const groups = exam.shifts
        ? [...exam.shifts.map(item => item.groups || [])].flat()
        : []
      return groups.reduce((count, group) => group.student + count, 0)
    },
    getCapacityOfNokParticipants (exam) {
      const groups = exam.shifts
        ? [...exam.shifts.map(item => item.groups || [])].flat()
        : []
      return groups.reduce(
        (count, group) =>
          group.independent_estimate_participants_number + count,
        0
      )
    },
    getNokParticipantsCount (exam) {
      const participants = this.getParticipants(exam)
      return participants.reduce((count, participant) => {
        if (participant.files['de-participants-noc'].guid !== nullGuid) {
          return count++
        }
        return count
      }, 0)
    },
    getApprovedParticipants (exam) {
      return !!this.getParticipants(exam).filter(
        user => user.status === 'approved'
      ).length
    },
    isPassedParticipants (exam) {
      return !!this.getParticipants(exam).find(
        user =>
          user.status === 'passed' ||
          user.status === 'approved' ||
          user.status === 'registered'
      )
    },
    isDeCenterAccredited (exam) {
      return isDeCenterAccredited(exam.accred_comps, exam.flags)
    },
    isParticipantsApprovedInAllShifts (exam) {
      return (
        exam.shifts &&
        !exam.shifts.find(s => {
          if (s.groups) {
            return s.groups.find(g => {
              if (g.participants) {
                return g.participants.find(p => p.status === 'approved')
              } else {
                return true
              }
            })
          } else {
            return true
          }
        })
      )
    },

    async _fetch () {
      if (!this.filter.exam_status) {
        Object.assign(this.filter, {
          exam_status: this.default_exam_status
        })
      }
      // flags - String уже с готовыми хардкод данными
      // чтобы не переписывать бОльшую часть логики, для фильтров которые должны добавляться в строковео поле flags,
      // значения фильтров очищаются только здесь, далее к тому что уже есть в flags добавляется
      // те фильтры что нужны, таким образов фильтры сохрнаются и в урле и не нарушают логику работы приложения
      // и добавляются в нужное поле flags
      const formattedFilter = {
        ...this.filter,
        'type-of-certification': undefined,
        'format-demo-exam': undefined,
        'level-demo-exam': undefined
      }
      const arrFlags = [this.filter['type-of-certification'], this.filter['level-demo-exam']].filter((elem) => !!elem).join(',')
      const formattedFlags = arrFlags || this.flags
      if (this.isMy) {
        this.clearAllMy()
        try {
          await this.findMy({
            query: formattedFilter.humanreadble
              ? {
                ...formattedFilter,
                flags: formattedFlags,
                required_flags: this.filter['format-demo-exam'],
                page: this.page,
                per_page: this.per_page,
                role: this.currentRole
              }
              : {
                ...formattedFilter,
                'day_cm1.from': this.date.from,
                'day_cm1.till': this.date.to,
                flags: formattedFlags,
                required_flags: this.filter['format-demo-exam'],
                page: this.page,
                per_page: this.per_page,
                role: this.currentRole
              }
          })
        } catch (e) {
          if (!e) {
            return
          }
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
            type: 'is-danger'
          })
        }
      } else {
        this.clearAll()
        try {
          await this.find({
            query: formattedFilter.humanreadble
              ? {
                ...formattedFilter,
                flags: formattedFlags,
                required_flags: this.filter['format-demo-exam'],
                page: this.page,
                per_page: this.per_page
              }
              : {
                ...formattedFilter,
                'day_cm1.from': this.date.from,
                'day_cm1.till': this.date.to,
                flags: formattedFlags,
                required_flags: this.filter['format-demo-exam'],
                page: this.page,
                per_page: this.per_page
              }
          })
        } catch (e) {
          if (!e) {
            return
          }
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
            type: 'is-danger'
          })
        }
      }

      const examsListGuid = this.list.map(exam => exam.shifts[0] &&
      exam.shifts[0].groups[0] &&
      exam.shifts[0].groups[0].university &&
      exam.shifts[0].groups[0].university
        ? exam.shifts[0].groups[0].university.guid
        : exam.de_center.parent.guid)
      if (examsListGuid.length && examsListGuid !== constants.NULL_GUID && this.currentRole !== 'front_me') {
        this.curators = { ...this.curators, ...await this.findCurators([ examsListGuid, '/list' ]) }
      }
    },

    isCanApprove (exam) {
      return (
        !!exam.main_expert &&
        this.getApprovedParticipants(exam) &&
        exam.experts &&
        exam.experts.find(e => e.accepted)
      )
    },
    showHistory (exam) {
      this.$buefy.modal.open({
        parent: this,
        component: WsMainExpertHistory,
        scroll: 'clip',
        hasModalCard: true,
        canCancel: true,
        props: {
          history: exam.logging || [],
          examGuid: exam.guid
        }
      })
    },

    allParticipants (shifts) {
      return getAllParticipants(shifts)
    }
  },
  async created () {
    this.default_exam_status = `${constants.exam_status.AGREED_DE_DEPARTMENT},${
      constants.exam_status.CONFIRMED_AUTH_ORG
    },${constants.exam_status.CONFIRMED_AUTH_ORG_BLOCKED},${
      constants.exam_status.APPROVED_MAIN_EXPERT
    },
    ${constants.exam_status.APPROVED_MAIN_EXPERT_BLOCKED},${constants.exam_status.COMPLETE_MAIN_EXPERT},,${constants.exam_status.COMPLETE_MAIN_EXPERT_BLOCKED}`
    switch (this.currentRole) {
      case 'front_50plus':
        this.flags = constants.exam_flags.FIFTY_PLUS
        break
      case 'front_mio':
        this.flags = constants.exam_flags.MPO
        break
      case 'front_university':
        this.flags = constants.exam_flags.VUZ
        break
      case 'front_me':
        this.flags = `${constants.exam_flags.VUZ},${
          constants.exam_flags.FIFTY_PLUS
        },${constants.exam_flags.MPO},${constants.exam_flags.REGIONAL}`
        break
      case 'front_dep':
        this.flags = `${constants.exam_flags.VUZ},${
          constants.exam_flags.REGIONAL
        }`
        break
      case 'front_education_ministry':
        this.flags = `${constants.exam_flags.VUZ},${
          constants.exam_flags.REGIONAL
        }`
        break
      case 'front_admin':
        this.flags = `${constants.exam_flags.VUZ},${
          constants.exam_flags.REGIONAL
        },${constants.exam_flags.FIFTY_PLUS},${constants.exam_flags.MPO}`
        break
      case 'front_mc':
        this.flags = `${constants.exam_flags.VUZ},${
          constants.exam_flags.REGIONAL
        }`
        break
      case 'front_curator_institution':
        this.flags = `${constants.exam_flags.VUZ}`
        break
      default:
        this.flags = constants.exam_flags.REGIONAL
    }
    const unwatchFilter = this.$watch('filter', function () {
      this.ready++
      unwatchFilter()
    })
  }
}
</script>
<style lang="scss" scoped>
.mr-1 {
  margin-right: 0.5rem;
}
.inline-flex {
  display: inline-flex;
  align-items: center;

  > svg {
    margin-right: 0.2rem;
    margin-left: 0.2rem;
  }
}

.ws-demo-exams__item-system {
  margin-top: -1rem;

  &_old {
    color: #7a7a7a;
  }

  &_new-cis {
    color: #5495b7;
  }
}
</style>
